import { withInstall } from '@code-monkey-ui/utils'
import Watermark from './src/watermark.vue'

export const ElWatermark = withInstall(Watermark)
export default ElWatermark

export * from './src/watermark'
